import { formatMinutes } from './dateUtils';

export const rechartsDataFromMetrics = (
  sensorMetricsArrays,
  fromDate,
  toDate,
  hourUnit
) => {
  const millisecondsInMinutes = 60 * 1000;
  const dateToMinBefore = (date) =>
    Math.round((toDate - date) / millisecondsInMinutes);

  // Get increment and anchorDate from the first metrics arrays that has it
  let anchorDate;
  let increment;
  for (const metrics of sensorMetricsArrays) {
    if (metrics.frequencyInMinutes) {
      increment = metrics.frequencyInMinutes;
    }
    if (metrics.data.length > 0) {
      anchorDate = new Date(metrics.data[0].timestamp);
    }

    if (increment && anchorDate) {
      break;
    }
  }

  if (!anchorDate || !increment) {
    return [];
  }

  // Sometimes data 1 increment outside of window is returned
  const correctedFromDate = new Date(fromDate);
  correctedFromDate.setMinutes(correctedFromDate.getMinutes() - increment);

  let timestamps = {};
  timestamps[dateToMinBefore(anchorDate)] = {};
  timestamps[dateToMinBefore(correctedFromDate)] = {};
  timestamps[dateToMinBefore(toDate)] = {};

  // Get all dates before anchor
  const potentialDateBefore = new Date(anchorDate.getTime());
  while (potentialDateBefore >= correctedFromDate) {
    timestamps[dateToMinBefore(potentialDateBefore)] = {};
    potentialDateBefore.setMinutes(
      potentialDateBefore.getMinutes() - increment
    );
  }

  // Get all dates after anchor
  const potentialDateAfter = new Date(anchorDate.getTime());
  while (potentialDateAfter <= toDate) {
    timestamps[dateToMinBefore(potentialDateAfter)] = {};
    potentialDateAfter.setMinutes(potentialDateAfter.getMinutes() + increment);
  }

  sensorMetricsArrays.forEach((metrics) => {
    metrics.data.forEach((reading) => {
      const dateInMinBeforeNow = dateToMinBefore(new Date(reading.timestamp));
      if (timestamps[dateInMinBeforeNow]) {
        timestamps[dateInMinBeforeNow][metrics.deviceSensorId] =
          Math.round(reading.value * 100) / 100;
      }
    });
  });

  let data = [];
  Object.entries(timestamps).forEach(([key, value]) => {
    data.push({ name: formatMinutes(key, hourUnit, true), ...value });
  });

  data.reverse();

  return data;
};
